import { render, staticRenderFns } from "./MemoEdit.vue?vue&type=template&id=55c8c889&scoped=true"
import script from "./MemoEdit.vue?vue&type=script&lang=js"
export * from "./MemoEdit.vue?vue&type=script&lang=js"
import style0 from "./MemoEdit.vue?vue&type=style&index=0&id=55c8c889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8c889",
  null
  
)

export default component.exports